export default __webpack_public_path__ + "static/media/icon_collect_status_no_pass.39c90e3e.png";